import { THEME_NAMES } from "./config";
import { assetPackIds } from "nemuru-components";

export const iberiaTheme = {
  zendeskCustomerSupport: false,
  themeName: THEME_NAMES.iberia,
  logoUrl: "https://cdn.nemuru.com/assets/logos/iberia-logo.svg",
  palette: {
    primary: {
      main: "#D7192D",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#000",
      contrastText: "#ffffff",
    },
    dark: {
      main: "#f2f4ff",
      contrastText: "#000",
      accent: "#D7192D",
      imageBackgroundOpacity: 0.85,
    },
    text: {
      title: "#333333",
      primary: "#333333",
      secondary: "#666666",
    },
    status: {
      active: "#4ac687",
      approved: "#349a65",
      analysing: "#06f",
      sent: "#031A34",
      cancelled: "#d8d8d8",
      denied: "#D7192D",
    },
    info: {
      main: "#D7192D",
      contrastText: "#ffffff",
      light: "#f2f4ff",
    },
    warning: {
      main: "#fcd100",
      contrastText: "#ffffff",
      light: "#fff6e7",
    },
    success: {
      main: "#1a8907",
      contrastText: "#ffffff",
      light: "rgba(76, 205, 138,0.6)",
    },
    grey: {
      50: "#fcfcfc",
      100: "#fcfcfc",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  background: "#f4f4f4",
  customBorderRadius: {
    button: 0,
    paper: 0,
  },
  shadows: [
    "none",
    "none",
    "none", // 2 buttons
    "none", // 3 papers soft
  ],
  typography: {
    fontFamily:
      'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  },
};
